import { useContext } from 'react'
import DeleteIcon from '@mui/icons-material/Delete'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { useDispatch } from 'react-redux'
import { modalContext } from '@contexts'
import { api } from 'api'
import { showSnackbar } from 'functions'
import { t } from '@lingui/core/macro'

export const DeleteDatasetIcon = ({ datasetId, invalidateQueryCache, setDeleting, canDelete }) => {
  const dispatch = useDispatch()
  const ModalContext = useContext(modalContext)

  const deleteDataset = datasetId => {
    setDeleting(prev => ({
      ...prev,
      [datasetId]: true,
    }))
    api
      .delete(`/api/v1/account/dataset/${datasetId}`)
      .then(response => {
        setDeleting(prev => ({
          ...prev,
          [datasetId]: false,
        }))
        if (response.data.success) {
          invalidateQueryCache()
        }
        dispatch(
          showSnackbar({
            message: response.data.success
              ? t`Submission deleted successfully`
              : t`Submission failed to delete`,
            type: response.data.success ? 'SUCCESS' : 'ERROR',
            duration: 5000,
          }),
        )
      })
      .catch(() => {
        setDeleting(prev => ({
          ...prev,
          [datasetId]: false,
        }))
        dispatch(
          showSnackbar({
            message: t`Submission failed to delete`,
            type: 'ERROR',
            duration: 5000,
          }),
        )
      })
  }

  function deleteDatasetModal(datasetId, e) {
    ModalContext.displayModal({
      title: t`Are you sure you want to delete?`,
      description: t`This action can't be undone and any work will be lost.`,
      confirm: () => {
        return () => {
          deleteDataset(datasetId)
        }
      },
    })
    e.stopPropagation()
  }

  if (!canDelete) return null

  return (
    <IconButton
      style={{ padding: '4px' }}
      onClick={e => {
        e.stopPropagation()
        deleteDatasetModal(datasetId, e)
      }}
      size="large"
    >
      <Tooltip title={t`Delete`}>
        <DeleteIcon />
      </Tooltip>
    </IconButton>
  )
}
